import { Dispatch, SetStateAction } from "react";

import { Link, Tooltip, Typography } from "@mui/joy";

import { ReferenceProcessor } from "../util/references";

import { FileViewerArgs } from "./fileviewer/FileViewer";
import FileIcon from "./FileIcon";
import { AnalyticsEvents, analyticsEvent } from "../util/analytics";

interface ReferenceLinkProps {
    referenceKey: string;
    processor: ReferenceProcessor;
    currentFileViewerFile: FileViewerArgs | null;
    setCurrentFileViewerFile: Dispatch<SetStateAction<FileViewerArgs | null>>;
}

const styles = {
    messageReference: { borderRadius: 4, verticalAlign: "middle" },
    invalidReference: { display: "inline" },
};

export default function ReferenceLink(props: ReferenceLinkProps) {
    const { referenceKey, processor, currentFileViewerFile, setCurrentFileViewerFile } = props;

    if (!processor.isReferenceValid(referenceKey)) {
        return (
            <Typography
                level="body-xs"
                color="danger"
                variant="soft"
                sx={{ ...styles.messageReference, ...styles.invalidReference }}
            >
                Invalid ref {referenceKey}
            </Typography>
        );
    }

    const refInfo = processor.getInformationForReference(referenceKey, currentFileViewerFile);

    return (
        <Tooltip title={refInfo.description} sx={{ whiteSpace: "pre-line" }}>
            <Link
                href="#"
                level="body-sm"
                variant={refInfo.isReferenceOpen ? "solid" : "soft"}
                color={refInfo.isReferenceOpen ? "primary" : "neutral"}
                sx={styles.messageReference}
                startDecorator={<FileIcon fileName={refInfo.fileViewerArgs.file.fileName} />}
                onClick={(e) => {
                    e.preventDefault();
                    analyticsEvent(AnalyticsEvents.CONVERSATION_VIEW_REFERENCE);

                    // If the reference is active then hide it, otherwise open
                    const args = refInfo.isReferenceOpen ? null : refInfo.fileViewerArgs;
                    setCurrentFileViewerFile(args);
                }}
            >
                {refInfo.text}
            </Link>
        </Tooltip>
    );
}
